<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title float-left"> Категории</h4>
                        <router-link tag="button" class="btn btn-success float-right" to="/category/new">Добавить
                        </router-link>
                    </div>
                    <div class="card-body table-responsive">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th width="10%" class="text-center">Изображение</th>
                                    <th width="20%">Название</th>
                                    <th width="20%">Название(RU)</th>
                                    <th width="10%">Родитель</th>
                                    <th width="10%">Сортировка</th>
                                    <th width="15%" class="d-none d-md-table-cell">Создано</th>
                                    <th width="15%" class="d-none d-md-table-cell">Обновлено</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody v-if="!loading && results && results.data">
                                <tr v-for="result in results.data" :key="result.id">
                                    <td class="text-center">
                                        <img :src="result.photo.url" style="max-width: 50px;max-height: 50px" v-if="result.photo && result.photo.url"/>
                                    </td>
                                    <td>{{result.name}}</td>
                                    <td>{{result.nameRu}}</td>
                                    <td>{{result.parent ? result.parent.name : ''}}</td>
                                    <td>{{result.sortOrder}}</td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.createdBy">{{result.createdBy.name}}</div>
                                        <div v-if="result.createdDate">{{result.createdDate}}</div>
                                    </td>
                                    <td class="d-none d-md-table-cell">
                                        <div v-if="result.updatedBy">{{result.updatedBy.name}}</div>
                                        <div v-if="result.updatedDate">{{result.updatedDate}}</div>
                                    </td>
                                    <td>
                                        <div class="btn-group btn-group-sm">
                                            <router-link :to="'/category/edit/' + result.id" tag="button" class="btn btn-info">
                                                <i class="fa fa-pencil"></i>
                                            </router-link>
                                            <button class="btn btn-danger" @click="deleteDialog(result)">
                                                <i class="fa fa-remove"></i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="text-center">
                            <div class="loader mt-5 mb-5" v-if="loading"></div>
                            <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">Нет данных</span>
                        </div>
                        <div class="row" v-if="!loading && results && results.pageCount && results.pageCount > 1 ">
                            <div class="col-12 pt-3 pb-3">
                                <b-pagination :total-rows="results.total" v-model="filter.page" :per-page="filter.pageSize" @change="onPageChange">
                                </b-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {BPagination} from 'bootstrap-vue';
    // import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import FilterModel from './../../shared/filter';

    export default {
        name: "CategoryList",
        components: {
            'b-pagination': BPagination
        },
        data() {
            return {
                loading: false,
                filter: new FilterModel(),
                results: null,
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.get('category', this.filter.asQuery())
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    }, err => {
                        console.log(err);
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page = page;
                this.initList();
            },
            deleteCategory(category) {
                this.$http.delete('category/' + category.id)
                    .then(() => {
                        this.initList();
                    }, () => {
                        this.$swal({
                            title: 'Ошибка',
                            text: 'Ошибка при удалении категории',
                            type: 'error'
                        });
                    });
            },
            deleteDialog(item) {
                this.$swal({
                    title: 'Удалить?',
                    text: 'Вы действительно хотите удалить эту категорию?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Удалить',
                    cancelButtonText: 'Отменить',
                    confirmButtonColor: '#E5343D'
                }).then((result) => {
                    if (result.value) {
                        this.deleteCategory(item);
                    }
                });
            }
        },
        created() {
            this.initList();
        }
    }
</script>

<style scoped>

</style>